var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dropdown',{attrs:{"disabled":_vm.model === 'admin',"items":_vm.roles,"label":_vm.$t('user_type'),"item-text":"text","item-value":"val","rules":[_vm.rules.required],"required":"","dense":""},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }